<template>
<div>
                        <v-card class="px-4">
                            <v-card-text>
                                <h3>To accept your invitation to join Memories For Us, use the form below.</h3>
                                <h3>Once you register, your free {{charterType}} subscription will begin!</h3>
                              <p v-if="regmessage">{{regmessage}}</p>
                                <v-form ref="registerForm" v-model="valid" lazy-validation>
                                  <p>{{errMsg}}</p>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="firstName" :rules="[rules.required]" label="First Name" maxlength="50" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="lastName" :rules="[rules.required]" label="Last Name" maxlength="50" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" >
                                            <v-text-field v-model="displayName" :rules="[rules.required]" label="How you want your name to appear to others" maxlength="100" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Password" hint="At least 8 characters" counter @click:append="show1 = !show1"></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field block v-model="verify" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required, passwordMatch]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Confirm Password" counter @click:append="show1 = !show1"></v-text-field>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col class="d-flex ml-auto" cols="12" sm="3" xsm="12">
                                            <v-btn x-large block :disabled="!valid" color="secondary" @click="validateReg">Register</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row><v-btn 
                                    large 
                                    block 
                                    icon
                                     @click="$router.push({name: 'Start'})"
                                    
                                    ><v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
</div>
</template>
<script>

import EventService from '@/services/EventService.js'; 


export default {
  name: 'acceptinvitation',

  data() {
    return {
       invitationID: '',
       valid: true,
    
    firstName: "",
    lastName: "",
    displayName: "",
    email: "",
    password: "",
    charterType: "30 day",
    verify: "",
    regmessage: '',
    errMsg:'',
    show1: false,
    invitation: [],
    emailRules: [
      v => !!v || "Required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],

    loggedin: false,
 //   show1: false,
    rules: {
      required: value => !!value || "Required.",
      min: v => (v && v.length >= 8) || "Min 8 characters"
    }
       }
    },

computed: {
    passwordMatch() {
      return () => this.password === this.verify || "Password must match";
    },
    user(){
    return this.$store.state.user
  },
},

mounted() {

this.invitationID = this.$route.params.invitationID;
this.regmessage = ''
this.getInvitation();
  },

methods: {
async validateReg() {
        if (this.$refs.registerForm.validate()) {
        // submit form to server/API here...
        this.tab = 1;
        this.errMsg = '';
        this.registration(this.email, this.password, this.firstName, this.lastName, this.displayName)
      }
    },

async getInvitation() {
         await  EventService.getInvitation(this.invitationID)
         .then((invitation) => {
          this.$set(this, "invitation", invitation);
          if(this.invitation.InvitationType === 2 || this.invitation.InvitationType === 3) {
              this.charterType = 'LIFETIME'
          }
         })
         .then(() => {
         })
      },

resetValidation() {
      this.$refs.form.resetValidation();
    },

async registration() {
      if (this.email.toLowerCase() === this.invitation.InviteEmail.toLowerCase()) {
      EventService.invitedRegistration(this.firstName, this.lastName, this.displayName, this.email, this.password, this.invitationID, this.invitation.InvitationType)
      .then((dupcheck) => {
        if (dupcheck === 'duplicate') {
          this.regmessage = 'This email address is already registered'
          return
        } else {
        this.$router.push({ name: 'RegistrationConfirmation' })
        }
      }
      )
      } else {
          this.errMsg = 'The email address you enter must match the email that the invitation was sent to. Please check the spelling and try again.'
      }
    }
}}

</script>
<style lang="scss" scoped>



</style>